module.exports = __webpack_public_path__ + "static/media/decentralized.f7d4a0b9.png";